export const BUILD_INFO = {
  "MEMBERS_UI_IMAGE": "registry.gitlab.com/mit-esolutions/sitos-x/sitos-x-frontend",
  "releaseType": "DEV",
  "MEMBERS_UI_VERSION": "dev",
  "semVer": "100.1.0-dev",
  "grow": 1,
  "MEMBERS_UI": "registry.gitlab.com/mit-esolutions/sitos-x/sitos-x-frontend:dev",
  "TARGET_PLATFORMS": "linux/amd64",
  "serviceName": "members-ui",
  "semVerMajor": 1,
  "buildDate": "2021-01-01T00:00:00.0000000+00:00",
  "DOCKER_TAG": "dev",
  "DOCKER_TAG_ALTERNATE": "dev",
  "DEFAULT_CI_REGISTRY_IMAGE": "registry.gitlab.com/mit-esolutions/sitos-x/sitos-x-frontend"
} as const;
